import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { DespreHero } from '../components/despre/DespreHero';
import { DespreStory } from '../components/despre/DespreStory';
import { DespreMethod } from '../components/despre/DespreMethod';
import { DespreMission } from '../components/despre/DespreMission';
import { DespreCredentials } from '../components/despre/DespreCredentials';
import { DespreOffers } from '../components/despre/DespreOffers';
import { DespreFinalCTA } from '../components/despre/DespreFinalCTA';
export function DespreminePage() {
  return <div className="min-h-screen bg-brand-cream font-body text-brand-text selection:bg-brand-gold selection:text-white overflow-x-hidden" data-id="element-2353">
      <Header data-id="element-2354" />
      <main data-id="element-2355">
        <DespreHero data-id="element-2356" />
        <DespreStory data-id="element-2357" />
        <DespreMethod data-id="element-2358" />
        <DespreMission data-id="element-2359" />
        <DespreCredentials data-id="element-2360" />
        <DespreOffers data-id="element-2361" />
        <DespreFinalCTA data-id="element-2362" />
      </main>
      <Footer data-id="element-2363" />
    </div>;
}